import michaelHjorthPhoto from "@/images/marketing/team/michael-hjorth.jpg";
import thomasMollerKnudsenPhoto from "@/images/marketing/team/thomas-moller-knudsen.jpg";
import johnLundsgaardPhoto from "@/images/marketing/team/john-lundsgaard.jpg";

const teamMembers = [
  {
    initials: "MH",
    name: "Michael Hjorth",
    role: "Direktør & Founder",
    photo: michaelHjorthPhoto,
    alt: "Michael Hjorth",
    objectPosition: "center top"
  },
  {
    initials: "TM",
    name: "Thomas Møller Knudsen",
    role: "Founder",
    photo: thomasMollerKnudsenPhoto,
    alt: "Thomas Møller Knudsen",
    objectPosition: "center top"
  },
  {
    initials: "JL",
    name: "John Lundsgaard",
    role: "Bestyrelsesformand",
    photo: johnLundsgaardPhoto,
    alt: "John Lundsgaard",
    objectPosition: "center top"
  }
];

export default teamMembers;
